var map = {
	"./10kwine-invest.jpg": [
		89540,
		540
	],
	"./1kwine-invest.jpg": [
		49511,
		511
	],
	"./5kwine-invest.jpg": [
		23435,
		435
	],
	"./empower_your_investing.jpeg": [
		51527,
		527
	],
	"./why_invest_in_wine_key_benefits.jpeg": [
		72889,
		889
	],
	"./why_smart_investors_look_to_alternative_assets.jpg": [
		61304,
		304
	],
	"./wine_investment_guide_for_beginners.jpeg": [
		29726,
		726
	],
	"./wine_investment_vs_stock.jpeg": [
		76830,
		830
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 83901;
module.exports = webpackAsyncContext;